import { render } from "./Brief.vue?vue&type=template&id=126233df&scoped=true"
import script from "./Brief.vue?vue&type=script&lang=js"
export * from "./Brief.vue?vue&type=script&lang=js"

import "./Brief.vue?vue&type=style&index=0&id=126233df&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-126233df"]])

export default __exports__